<template>
    <va-card class="flex mb-4">
        <va-card-title style="height: 30px; padding: 5px; padding-left: 20px"
            >培训课程管理</va-card-title
        >
        <va-card-content>
            <div>
                <div>
                    <vxe-form :data="toolbar.formData">
                        <vxe-form-item title="课程等级" :item-render="{}">
                            <template #default="{ data }">
                                <vxe-select
                                    v-model="data.course_level"
                                    placeholder="全部"
                                    clearable
                                    style="width: 100px"
                                >
                                    <vxe-option
                                        value="1"
                                        label="基础课程"
                                    ></vxe-option>
                                    <vxe-option
                                        value="2"
                                        label="中级课程"
                                    ></vxe-option>
                                    <vxe-option
                                        value="3"
                                        label="高级课程"
                                    ></vxe-option>
                                </vxe-select>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item title="技术分类" :item-render="{}">
                            <template #default="{ data }">
                                <vxe-select
                                    v-model="data.course_type"
                                    :options="toolbar.courseTypes"
                                    placeholder="全部"
                                    clearable
                                    style="width: 100px"
                                >
                                </vxe-select>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item title="实施状态" :item-render="{}">
                            <template #default="{ data }">
                                <vxe-select
                                    v-model="data.status"
                                    placeholder="全部"
                                    clearable
                                    style="width: 90px"
                                >
                                    <vxe-option
                                        value="0"
                                        label="未实施"
                                    ></vxe-option>
                                    <vxe-option
                                        value="1"
                                        label="已实施"
                                    ></vxe-option>
                                </vxe-select>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item title="培训年度" :item-render="{}">
                            <template #default="{ data }">
                                <vxe-input
                                    type="year"
                                    v-model="data.train_year"
                                    placeholder="全部"
                                    clearable
                                    style="width: 90px"
                                ></vxe-input>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item
                            title="关键字"
                            field="searchKey"
                            :item-render="{}"
                        >
                            <template #default="{ data }">
                                <vxe-input
                                    v-model="data.searchKey"
                                    placeholder="请输入课程名称"
                                    clearable
                                ></vxe-input>
                            </template>
                        </vxe-form-item>

                        <vxe-form-item>
                            <template #default>
                                <vxe-button
                                    status="primary"
                                    @click="findData"
                                    @keyup.enter="findData"
                                    >查询</vxe-button
                                >
                                <vxe-button @click="clear">重置</vxe-button>
                                <vxe-button
                                    status="success"
                                    @click="add"
                                    v-if="isAdmin"
                                    >新增</vxe-button
                                >
                            </template>
                        </vxe-form-item>
                    </vxe-form>
                </div>
                <div style="overflow: hidden; height: 100%">
                    <vxe-table
                        stripe
                        class="mytable-scrollbar"
                        :data="tableData"
                        :height="tableHeight"
                        show-overflow
                        :row-config="{
                            height: 36,
                            isHover: true,
                            isCurrent: true,
                        }"
                        ref="xTable1"
                    >
                        <vxe-column
                            type="seq"
                            title="序号"
                            width="50"
                        ></vxe-column>
                        <vxe-column title="删除" width="50" v-if="isAdmin">
                            <template #default="{ row }">
                                <vxe-button
                                    type="text"
                                    icon="fa fa-trash-o"
                                    @click="removeRowEvent(row)"
                                ></vxe-button>
                            </template>
                        </vxe-column>
                        <vxe-column
                            title="编辑"
                            width="50"
                            show-overflow
                            :visible="isAdmin"
                        >
                            <template #default="{ row }">
                                <vxe-button
                                    type="text"
                                    icon="fa fa-edit"
                                    @click="editEvent(row)"
                                ></vxe-button>
                            </template>
                        </vxe-column>
                        <vxe-column title="报名操作" width="120" align="center">
                            <template #default="{ row }">
                                <vxe-button
                                    type="text"
                                    icon="fa fa-search"
                                    title="查看报名名单"
                                    @click="viewEnrollList(row)"
                                >
                                </vxe-button>
                                <vxe-button
                                    type="text"
                                    icon="fa fa-upload"
                                    title="导入名单"
                                    v-if="isAdmin"
                                    @click="uploadEnrollList(row)"
                                >
                                </vxe-button>
                                <vxe-button
                                    type="text"
                                    icon="fa fa-retweet"
                                    title="转成需求"
                                    v-if="isAdmin"
                                    @click="changeToReqs(row)"
                                >
                                </vxe-button>
                            </template>
                        </vxe-column>
                        <vxe-column
                            title="签到操作"
                            width="100"
                            align="center"
                            visible="isAdmin"
                        >
                            <template #default="{ row }">
                                <vxe-button
                                    type="text"
                                    icon="fa fa-search"
                                    title="查看签到名单"
                                    @click="viewSignInList(row)"
                                >
                                </vxe-button>
                                <vxe-button
                                    type="text"
                                    icon="fa fa-sign-in"
                                    title="导入签到数据"
                                    v-if="isAdmin"
                                    @click="uploadEnrollCheck(row)"
                                >
                                </vxe-button>
                            </template>
                        </vxe-column>
                        <vxe-column
                            field="course_name"
                            title="课程名称"
                            width="160"
                            sortable
                            show-overflow
                            resizable
                        ></vxe-column>
                        <vxe-column
                            field="course_type_name"
                            title="技术分类"
                            width="100"
                            show-overflow
                            resizable
                            sortable
                        ></vxe-column>
                        <vxe-column
                            field="course_period"
                            title="授课日期"
                            width="190"
                            show-overflow
                            resizable
                            sortable
                        ></vxe-column>
                        <vxe-column
                            field="teach_method_name"
                            title="授课方式"
                            width="100"
                            show-overflow
                            resizable
                            sortable
                        ></vxe-column>
                        <vxe-column
                            field="lecturerName"
                            title="讲师"
                            width="100"
                            resizable
                        ></vxe-column>
                        <vxe-column
                            field="enroll_method_name"
                            title="报名方式"
                            width="100"
                            sortable
                        ></vxe-column>
                        <vxe-column
                            field="status_name"
                            title="实施状态"
                            width="100"
                            resizable
                            sortable
                            show-overflow
                        >
                            <template v-slot="{ row }">
                                <span
                                    :style="{
                                        color:
                                            row.status_name === '未实施'
                                                ? '#E6A23C'
                                                : '#67C23A',
                                    }"
                                >
                                    {{ row.status_name }}
                                </span></template
                            >
                        </vxe-column>
                        <vxe-column
                            field="enroll_period"
                            title="报名期间"
                            width="190"
                            sortable
                            show-overflow
                            resizable
                        ></vxe-column>

                        <vxe-column
                            field="enroll_count"
                            title="培训人次"
                            width="100"
                            sortable
                            show-overflow
                        ></vxe-column>
                        <vxe-column
                            field="is_transfer_xq_name"
                            title="是否已转需求"
                            width="140"
                            sortable
                        ></vxe-column>
                        <vxe-column
                            field="course_level_name"
                            title="课程等级"
                            width="100"
                            sortable
                        ></vxe-column>
                        <vxe-column
                            field="creator_name"
                            title="创建人"
                            width="100"
                            show-overflow
                            sortable
                            resizable
                        ></vxe-column>
                        <vxe-column
                            field="create_time"
                            title="创建时间"
                            width="160"
                            show-overflow
                            sortable
                            resizable
                        ></vxe-column>
                    </vxe-table>
                </div>
                <div>
                    <vxe-pager
                        background
                        v-model:current-page="tablePager.currentPage"
                        v-model:page-size="tablePager.pageSize"
                        :total="tablePager.totalResult"
                        @page-change="handlePageChange"
                        :page-sizes="[
                            10,
                            20,
                            100,
                            { label: '全部数据', value: 10000 },
                        ]"
                        :layouts="[
                            'PrevJump',
                            'PrevPage',
                            'JumpNumber',
                            'NextPage',
                            'NextJump',
                            'Sizes',
                            'FullJump',
                            'Total',
                        ]"
                    >
                    </vxe-pager>
                </div>
            </div>
        </va-card-content>
    </va-card>
    <addCourse ref="addCourseRef" @flashList="findData"></addCourse>
    <enrollList ref="enrollListRef" @flashList="findData"></enrollList>
    <signInList ref="signInListRef" @flashList="findData"></signInList>
    <importEnroll ref="importEnrollRef" @flashList="findData"></importEnroll>
    <importEnrollCheck
        ref="importEnrollCheckRef"
        @flashList="findData"
    ></importEnrollCheck>
</template>

<script setup>
import { reactive, ref, getCurrentInstance, onMounted, h } from "vue";
import { VXETable } from "vxe-table";
import Qs from "qs";
import XEUtils from "xe-utils";
import { useRouter } from "vue-router";
const router = useRouter();
const { proxy } = getCurrentInstance();
import addCourse from "./addCourse.vue";
import enrollList from "./enrollList.vue";
import importEnroll from "./importEnroll.vue";
import importEnrollCheck from "./importEnrollCheck.vue";
import signInList from "./signInList.vue";

const tableHeight = ref(400);
const tableData = ref([]);

const addCourseRef = ref(null);
const enrollListRef = ref(null);
const signInListRef = ref(null);
const importEnrollRef = ref(null);
const importEnrollCheckRef = ref(null);
const isAdmin = ref(false);
const formatTime = ({ cellValue }) => {
    return XEUtils.toDateString(cellValue, "yyyy-MM-dd");
};

const tablePager = reactive({
    currentPage: 1,
    pageSize: 10,
    totalResult: 0,
});

const toolbar = reactive({
    loading: false,
    courseTypes: [],
    formData: {
        course_level: "",
        course_type: "",
        status: "",
        train_year: "",
        searchKey: "",
    },
});

const add = () => {
    addCourseRef.value.openModal();
};
const editEvent = (row) => {
    addCourseRef.value.editEvent(row);
};

const findData = () => {
    const params = {
        uid: proxy.$store.state.userID,
        email: proxy.$store.state.email,
        currentPage: tablePager.currentPage,
        pageSize: tablePager.pageSize,
        searchKey: [
            toolbar.formData.course_level,
            toolbar.formData.course_type,
            toolbar.formData.status,
            toolbar.formData.train_year,
            toolbar.formData.searchKey,
        ],
    };
    proxy.$api.courseManageAPI
        .getCourseList(Qs.stringify(params))
        .then((res) => {
            if (res.data.Success == false) {
                VXETable.modal.message({
                    content: res.data.Message,
                    status: "error",
                });
                return;
            }
            // console.log(res.data.Data);
            tableData.value = res.data.Data.dataTable;
            tablePager.currentPage = res.data.Data.currentPage;
            tablePager.pageSize = res.data.Data.pageSize;
            tablePager.totalResult = res.data.Data.totalResult;
            tableHeight.value = calTableHeight(res.data.Data.dataTable.length);
        })
        .catch((error) => {
            console.log(error);
        });
};

const handlePageChange = (params) => {
    tablePager.currentPage = params.currentPage;
    tablePager.pageSize = params.pageSize;
    findData();
};

const calTableHeight = (rowsLength) => {
    let minHeight = window.innerHeight - (65 + 28 + 198);
    let calHeight = rowsLength == null ? 0 : (rowsLength + 1) * 36 + 30;
    return Math.max(minHeight, calHeight);
};

const bindCourseType = () => {
    const params = {
        uid: proxy.$store.state.userID,
        email: proxy.$store.state.email,
        currentPage: "",
        pageSize: "",
        searchKey: ["32"],
    };
    proxy.$api.systemManageAPI
        .getLookupValue(Qs.stringify(params))
        .then((res) => {
            if (res.data.Success == false) {
                VXETable.modal.message({
                    content: res.data.Message,
                    status: "error",
                });
                return;
            }
            // console.log(res.data.Data);
            toolbar.courseTypes = [];
            for (const item of res.data.Data) {
                toolbar.courseTypes.push({
                    value: item.LookupValueCode,
                    label: item.LookupValueName,
                });
            }
        })
        .catch((error) => {
            console.log(error);
        });
};

const clear = () => {
    toolbar.formData.searchKey = "";
    toolbar.formData.status = "";
    toolbar.formData.course_type = "";
    toolbar.formData.course_level = "";
    toolbar.formData.train_year = "";
};
const viewEnrollList = (row) => {
    enrollListRef.value.openModal(row);
};

const viewSignInList = (row) => {
    signInListRef.value.openModal(row);
};

const uploadEnrollList = (row) => {
    importEnrollRef.value.openModal(row);
};

const uploadEnrollCheck = (row) => {
    importEnrollCheckRef.value.openModal(row);
};
const changeToReqs = async (row) => {
    if (row.is_transfer_xq == "1") {
        VXETable.modal.message({
            content: "已经转换，不能重复转换",
            status: "warning",
        });
        return;
    }
    if (row.status == "0") {
        VXETable.modal.message({
            content: "已实施才能转需求",
            status: "warning",
        });
        return;
    }

    const type = await VXETable.modal.confirm(
        `确定要转换该课程下的所有课题为需求吗？

【1】报名时选择的历史需求不会重新生成需求
【2】已完成签到的培训课题将直接发起需求提交审批流
【3】未完成签到的培训课题将存为草稿状态的需求，由业务人员手动发起提交审批流`
    );

    if (type === "confirm") {
        const params = {
            uid: proxy.$store.state.userID,
            email: proxy.$store.state.email,
            currentPage: "",
            pageSize: "",
            searchKey: [row.id],
        };
        proxy.$api.courseManageAPI
            .transferXq(Qs.stringify(params))
            .then((res) => {
                if (res.data.Success == false) {
                    VXETable.modal.message({
                        content: res.data.Message,
                        status: "error",
                    });
                    return;
                }
                VXETable.modal.message({
                    content: "转换成功",
                    status: "success",
                });
                findData();
            })
            .catch((error) => {
                console.log(error);
            });
    }
};
const removeRowEvent = async (row) => {
    const type = await VXETable.modal.confirm("确定要删除该课程吗？");

    if (type === "confirm") {
        const params = {
            uid: proxy.$store.state.userID,
            email: proxy.$store.state.email,
            currentPage: tablePager.currentPage,
            pageSize: tablePager.pageSize,
            searchKey: [row.id],
        };
        proxy.$api.courseManageAPI
            .deleteCourse(Qs.stringify(params))
            .then((res) => {
                if (res.data.Success == false) {
                    VXETable.modal.message({
                        content: res.data.Message,
                        status: "error",
                    });
                    return;
                }
                VXETable.modal.message({
                    content: "删除成功",
                    status: "success",
                });
                findData();
            })
            .catch((error) => {
                console.log(error);
            });
    }
};
onMounted(() => {
    isAdmin.value = proxy.$store.state.isAdmin == "1";
    bindCourseType();
    findData();
});
</script>

<style lang="scss" scoped>
.mytable-style .vxe-body--column.col-red {
    background-color: red;
    color: #fff;
}

.active {
    color: green;
}

.error {
    color: red;
}

.audit {
    color: blue;
}
</style>

<style type="text/css">
td.vxe-body--column {
    vertical-align: middle;
}
</style>
